class TasksCompleted {
  value = $state<number>(0);
}

export const tasksCompleted = new TasksCompleted();